import { TFieldHierarchy } from './types'

export const FIELD_HIERARCHY: TFieldHierarchy[] = [
  'motorCarrierUser',
  'dispatcherId',
  'driverId',
  'trackingMethod',
  'carrierSignature',
]

export const TEST_IDS = {
  submitButton: 'sign-rate-con-button',
  carrierSignatureInput: 'carrier-signature-input',
  dispatcherSelect: 'dispatcher-select',
  motorCarrierUserSelect: 'motor-carrier-user-select',
}
